module.exports = __webpack_public_path__ + "static/media/B_E03.377abea1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/BLUE/B_E03.png
// module id = 62
// module chunks = 0